import { Loading } from '@shared/ui'
import { Footer } from '@widgets/footer'
import { Header } from '@widgets/header'
import { Suspense, useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

export const Layout = () => {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0,0)
  },[ pathname ])
  return (
    <>
      <Header/>
      <Suspense fallback={<Loading/>}>
        <Outlet/>
      </Suspense>
      <Footer/>
    </>
  )
}
